import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgError = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 12.742a.735.735 0 0 0-.212-.515L12.06 10l2.227-2.227a.735.735 0 0 0 0-1.03l-1.03-1.03a.735.735 0 0 0-1.03 0L10 7.938 7.773 5.712a.735.735 0 0 0-1.03 0l-1.03 1.03a.735.735 0 0 0 0 1.03L7.938 10l-2.227 2.227a.734.734 0 0 0 0 1.03l1.03 1.03a.735.735 0 0 0 1.03 0L10 12.062l2.227 2.227a.735.735 0 0 0 1.03 0l1.03-1.03a.735.735 0 0 0 .213-.516Z"
        fill="#BA031C"
      />
    </svg>
  );
};
export default SvgError;
